<template>
  <MarketCard class="promo">
    <CardHeader :eventId="eventId" />

    <EventName :class="[classes.eventName, 'event-name']" :eventId="eventId" />

    <PromoLogo
      :class="classes.promoLogo"
      :promoMarketName="marketData.promoMarketName"
      :marketName="marketData.marketName"
    />

    <div :class="[classes.promoWrapper]">
      <promo-fitted-text
        :promoText="promoText"
        alignment="center"
        justifyContent="center"
      ></promo-fitted-text>
    </div>

    <div :class="classes.oddsButtonWrapper">
      <Button
        v-if="!displayCtaButton"
        :class="[classes.oddsButton]"
        :marketId="marketId"
        :option="option"
      />
      <OddsText v-else :marketId="marketId" :option="option" />
    </div>
  </MarketCard>
</template>

<script lang="ts">
import { computed, ComputedRef, defineComponent } from "vue";
import MarketCard from "../../styled/MarketCard.vue";
import CardHeader from "../../CardHeader.vue";
import EventName from "../../EventNameVertical.vue";
import PromoFittedText from "../../PromoFittedText.vue";
import Button from "./Button.vue";
import OddsText from "./OddsText.vue";
import PromoLogo from "./Logo.vue";
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import {
  BrandContext,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { useShowWinnings } from "@fresh8/ad-data-composition/src/usePotentialWinnings";
import { composeMarket } from "@fresh8/ad-data-composition/src/betData";
import { Market } from "@fresh8/types/src/betData";
import { injectPromoOption } from "../../../hooks/usePromoOption";

const { useStyles } = createUseStyles(
  {
    eventName: {
      padding: "8px",
      borderBottom: props => `1px solid ${props.marketBorderColor || "#dcddf"}`
    },
    promoWrapper: {
      flex: "1 1 0",
      minHeight: "0px",
      padding: "3px 8px 0 8px",
      overflow: "hidden",
      boxSizing: "border-box",
      flexDirection: "column",
      display: "flex"
    },
    promoLogo: {
      paddingTop: "16px",
      height: "22px",
      margin: "auto"
    },
    oddsButton: {
      height: "35px",
      width: "100%",
      "& .odds-text": {
        fontSize: "14px"
      }
    },
    oddsButtonWrapper: {
      padding: "16px 8px 12px 8px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    resize: {
      pointerEvents: "none",
      zIndex: -99
    }
  },
  undefined
);

export default defineComponent({
  name: "LargeMPUPromo",
  components: {
    MarketCard,
    CardHeader,
    EventName,
    PromoFittedText,
    Button,
    PromoLogo,
    OddsText
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const { adTemplateBranding, headerBranding } =
      injectBrand() || ({} as BrandContext);
    const marketData = composeMarket(props.marketId) as ComputedRef<Market>;
    const { classesRef } = useStyles(adTemplateBranding);

    const option = injectPromoOption();

    const showWinnings = useShowWinnings();

    return {
      promoText: computed(() => option.value.promoText),
      classes: classesRef,
      marketData,
      option,
      displayCtaButton: computed(
        () => !showWinnings.value && headerBranding.value?.type === "cta"
      )
    };
  }
});
</script>
